export default "__VITE_ASSET__f15e6c81__"